import { DataTable, FormSectionHeader, Heading } from "@/components";
import useFixedWeight from "./useFixedWeight";
import { capitalize, levels } from "@/lib/utils";
import { Button } from "@/components/ui";
import { ConfigureDialog } from "../ConfigureDialog";

const FixedWeight = () => {
  const {
    breadcrumbData,
    currentFinanceYear,
    tableData,
    columns,
    level,
    onAdd,
    openConfigureDialog,
    setOpenConfigureDialog,
    type,
    configuredData,
    isView,
    hasCreatePermission
  } = useFixedWeight();

  return (
    <div className="p-4 md:p-6">
      <div className="mb-4 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <Heading title="Configure Fixed Weight" breadcrumbData={breadcrumbData} />
        <div className="text-xl md:text-2xl font-semibold leading-none text-primary">
          {currentFinanceYear}
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md">
        <div className="flex flex-row items-center justify-between p-3 pb-0">
          <FormSectionHeader className="font-semibold">{(levels as any)[level as any]}</FormSectionHeader>
          {isView || !hasCreatePermission ? <></> : <Button onClick={onAdd}>Add</Button>}
        </div>
        <DataTable
          data={tableData || []}
          columns={columns}
          className="border-0 shadow-none" />
      </div>

      {openConfigureDialog && <ConfigureDialog
        open={openConfigureDialog}
        setOpen={setOpenConfigureDialog}
        level={level}
        budgetType={type as any}
        configuredData={configuredData}
        title={`${(levels as any)[level as any]} - ${capitalize(configuredData?.action)} Rule`}
      />}
    </div>
  )
}

export default FixedWeight;